export default __webpack_public_path__ + "static/media/nope-not-here.a6a9eb0b.webp";